/*
 * CardsByBeard — automatische productrijen
 * Elk [data-cb-feed] element haalt zijn producten op via de Section Rendering API
 * (sections/cb-product-feed.liquid) en vervangt de laad-placeholders.
 * Snel toevoegen gaat via window.cbAddToCart (assets/cb-cart-extras.js).
 */
(function () {
  function hideSection(feed) {
    var section = feed.closest('[data-cb-feed-section]');
    if (section) section.hidden = true;
  }

  function load(feed) {
    if (feed.dataset.loaded) return;
    feed.dataset.loaded = 'true';

    var limit = parseInt(feed.dataset.limit, 10) || 4;
    var grid = feed.querySelector('[data-cb-feed-grid]');

    fetch(feed.dataset.url)
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = Array.prototype.slice.call(doc.querySelectorAll('[data-cb-feed-items] > li'), 0, limit);
        if (!items.length) return hideSection(feed);
        grid.replaceChildren.apply(
          grid,
          items.map(function (item) {
            return document.importNode(item, true);
          })
        );
        grid.setAttribute('aria-busy', 'false');
      })
      .catch(function () {
        hideSection(feed);
      });
  }

  function init() {
    var feeds = Array.prototype.slice.call(document.querySelectorAll('[data-cb-feed]:not([data-loaded])'));
    if (!('IntersectionObserver' in window)) return feeds.forEach(load);

    // Rijen die (bijna) direct in beeld staan meteen laden, de rest pas bij scrollen
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    feeds = feeds.filter(function (feed) {
      if (feed.getBoundingClientRect().top < viewport * 2) {
        load(feed);
        return false;
      }
      return true;
    });

    // Pas laden als de rij bijna in beeld komt
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          load(entry.target);
        });
      },
      { rootMargin: '600px 0px' }
    );
    feeds.forEach(function (feed) {
      observer.observe(feed);
    });
  }

  // Regel-eigenschappen: herkomst (verborgen) en margeregeling (zichtbaar in checkout en bestelling)
  function cbProps(source, btn) {
    var p = {};
    if (source) p._bron = source;
    if (btn.hasAttribute('data-cb-marge')) p.Btw = 'margeregeling (niet aftrekbaar)';
    return Object.keys(p).length ? p : null;
  }

  // Snel toevoegen (werkt ook voor kaarten die later zijn ingeladen)
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cb-quick-add]');
    if (!btn || btn.disabled) return;
    if (typeof window.cbAddToCart !== 'function') return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    // Herkomst (bijv. "Homepage › Nieuw binnen") gaat als verborgen _bron mee naar de bestelling
    var source = typeof window.cbSourceFor === 'function' ? window.cbSourceFor(btn) : '';
    window
      .cbAddToCart(parseInt(btn.dataset.cbQuickAdd, 10), 1, cbProps(source, btn))
      .then(function () {
        btn.textContent = '✓ Toegevoegd';
        btn.classList.add('cb-pcard__add--added');
      })
      .catch(function () {
        btn.textContent = 'Kon niet toevoegen';
      })
      .then(function () {
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
          btn.classList.remove('cb-pcard__add--added');
        }, 2500);
      });
  });

  // Collectiepagina: "Toon meer producten" — volgende batch zichtbaar maken (werkt ook na filteren)
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cb-load-more]');
    if (!btn) return;
    var wrap = btn.closest('[data-cb-load-more-wrap]');
    var container = btn.closest('.collection') || document;
    var grid = container.querySelector('#product-grid');
    if (!grid) return;
    var firstHidden = grid.querySelector('[data-cb-batch][hidden]');
    if (!firstHidden) return;
    var batch = firstHidden.getAttribute('data-cb-batch');
    var revealed = grid.querySelectorAll('[data-cb-batch="' + batch + '"]');
    revealed.forEach(function (el) {
      el.hidden = false;
    });
    var shown = grid.querySelectorAll('.cb-grid-item:not([hidden])').length;
    var counter = wrap && wrap.querySelector('[data-cb-shown]');
    if (counter) counter.textContent = shown;
    // Toetsenbord/screenreader: focus naar het eerste nieuwe product
    var firstLink = grid.querySelector('.cb-grid-item[data-cb-batch="' + batch + '"] a');
    if (firstLink) firstLink.focus({ preventScroll: true });
    if (!grid.querySelector('[data-cb-batch][hidden]') && wrap) wrap.remove();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor: opnieuw laden als een sectie wordt aangepast
  document.addEventListener('shopify:section:load', init);
})();
